import type { UserPreferenceKeys } from '$lib/utilities/userPreferences/consts';

export function createUserPreferenceQueryKey(key?: UserPreferenceKeys | string) {
	const constructedKey = ['userPreference'];
	if (key) {
		constructedKey.push(key);
	}
	return constructedKey;
}
